<div class="navbar navbar-default navbar-fixed-bottom footer">
    <ul class="nav navbar-nav visible-xs-block">
        <li>
            <a class="text-center collapsed" data-toggle="collapse" data-target="#footer">
                <i class="icon-circle-up2"></i>
            </a>
        </li>
    </ul>

    <div class="navbar-collapse collapse" id="footer">
        <div class="navbar-text">
            &copy; 2021.
            <a href="http://kavanatech.com" class="navbar-link" target="_blank" class="navbar-link">Debo Equb Admin</a>
            by
            <a href="http://kavanatech.com" class="navbar-link" target="_blank">Kavana Technologies</a>
        </div>
    </div>
</div>